import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import Controls from '../../../../Vdp/BidBox/Controls';
import convertToCurrency from '../../../../../_shared/utils/convertToCurrency';
import {
  TradeState,
  TradeViewVariant
} from '../../../../../_shared/types/trade';
import { BidSource } from '../../../../../_shared/types/auction';
import ReducerConstants from '../../../../../_shared/constants/reducers';
import useMpBidTracking from '../../../../../_shared/hooks/useMixpanelBidTracking';
import { StyledListBidInput } from './Styles';

const ListBidBox = ({
  testId,
  bidAmount,
  bidIncrements,
  bidStatus,
  bidMpEventName,
  bidType,
  currentBidAmount,
  currentProxyAmount,
  minBidAmount,
  isAuctionEnded,
  isLoading,
  numberOfBids,
  hasVehicleHistoryReport,
  onBidButtonClick,
  onQuickBidButtonClick,
  onProxyButtonClick,
  onBidAmountChange,
  tradeState,
  formErrors,
  formSubmitting,
  tradeSummary: { auctionSummary, details, id },
  bidSuccess,
  setBidSuccess,
  manufacturers
}) => {
  const [mpBidError, setMpBidError] = useState([]);
  const [trackBidFlag, setTrackBidFlag] = useState(false);
  const [trackBidErrorFlag, setTrackBidErrorFlag] = useState(false);

  const [liveBid, bidList, user] = useSelector(
    state => [
      state[ReducerConstants.LIVE_BIDS][id],
      state[ReducerConstants.BID_LIST],
      state[ReducerConstants.AUTH]?.user
    ],
    shallowEqual
  );
  const [listBidAmount, setListBidAmount] = useState('');
  const onListBidAmountChange = amount => {
    if (!amount) {
      setListBidAmount('');
      onBidAmountChange('');
      return;
    }

    const intAmount = parseInt(amount, 10);
    if (Number.isNaN(intAmount)) {
      setListBidAmount('');
      onBidAmountChange('');
    } else {
      setListBidAmount(amount);
      onBidAmountChange(amount);
    }
  };

  const onListBidButtonClick = () => {
    onBidButtonClick(listBidAmount);
  };

  // Clear the input field if bid is successful
  useEffect(() => {
    if (bidSuccess) {
      setListBidAmount('');
      setBidSuccess(false);
    }
  }, [bidSuccess, setBidSuccess]);

  useMpBidTracking({
    tradeDetails: { auctionSummary, details, id },
    trackBidFlag,
    tradeProxyFlag: false,
    trackBidErrorFlag,
    mpBidError,
    proxyAmount: null,
    numberOfBids,
    bidStatus,
    bidAmount,
    liveBid,
    tradeState,
    manufacturers,
    bidSource: BidSource.LIST_BIDBOX,
    bidMpEventName,
    bidType,
    setMpBidError,
    setTrackBidFlag,
    setTrackProxyFlag: null,
    setTrackBidErrorFlag,
    bidUsers: bidList?.users,
    userId: user?.id
  });

  return (
    !isLoading && (
      <>
        {tradeState === TradeState.active && !currentProxyAmount && (
          <StyledListBidInput
            type="number"
            placeholder={`Min ${convertToCurrency(minBidAmount)}`}
            data-testid={`${testId}-bid-input`}
            min={minBidAmount}
            step={bidIncrements}
            value={listBidAmount}
            variant={formErrors.ERROR_BID && 'error'}
            onChange={e => {
              onListBidAmountChange(String(e.target.value));
            }}
            onClick={e => {
              e.stopPropagation();
            }}
          />
        )}
        <Controls
          bidAmount={listBidAmount}
          testId={testId}
          bidStatus={bidStatus}
          bidIncrements={bidIncrements}
          currentBidAmount={currentBidAmount}
          currentProxyAmount={currentProxyAmount}
          isAuctionEnded={isAuctionEnded}
          isLoading={isLoading}
          numberOfBids={numberOfBids}
          hasVehicleHistoryReport={hasVehicleHistoryReport}
          onBidButtonClick={onListBidButtonClick}
          onProxyButtonClick={onProxyButtonClick}
          onQuickBidButtonClick={onQuickBidButtonClick}
          tradeState={tradeState}
          formSubmitting={formSubmitting}
          variant={TradeViewVariant.LIST}
          tradeId={id}
          minBidAmount={minBidAmount}
        />
      </>
    )
  );
};

export default ListBidBox;
